import { useEffect, useState } from 'react'

/**
 * Hides the loading overlay and releases the scroll lock.
 *
 * Releasing the lock is load-bearing, not incidental: `_global.scss` ships
 * `body { position: fixed }`, so the page is scroll-locked until the preloader
 * clears. Forgetting it leaves the whole site unscrollable.
 *
 * @returns whether the preloader should still be rendered
 */
export function usePreloader(): boolean {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    document.body.style.position = 'static'
    setVisible(false)
    return () => {
      // Leave the body scrollable if this shell ever unmounts.
      document.body.style.position = 'static'
    }
  }, [])

  return visible
}
